import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'AIRemoteMergeView',
    props: {
        state: {
            type: Object,
            default: null,
        },
        startError: {
            type: String,
            default: '',
        },
        starting: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['retry', 'openEditor', 'openPreview'],
    render() {
        if (this.startError) {
            return (<div class="h-full flex items-center justify-center p-8">
          <div class="w-full max-w-xl">
            <a-result status="error" title={$t('k_43b7368f')} sub-title={this.startError}>
              <template slot="extra">
                <a-button type="primary" loading={this.starting} onClick={() => this.$emit('retry')}>
                  {$t('k_a815dd36')}
                </a-button>
              </template>
            </a-result>
          </div>
        </div>);
        }
        return (<div class="h-full flex items-center justify-center p-8">
        <div class="text-center">
          <a-spin size="large"/>
          <div class="mt-5 text-lg font-medium text-gray-900">
            {$t('k_ac06d6c7')}
          </div>
          <div class="mt-2 text-sm text-gray-500">
            {this.state?.message || $t('k_41059e82')}
          </div>
          <div class="mt-6 flex justify-center gap-3">
            <a-button type="primary" onClick={() => this.$emit('openEditor')}>
              {$t('k_45315b7c')}
            </a-button>
            <a-button onClick={() => this.$emit('openPreview')}>
              {$t('k_afba92f3')}
            </a-button>
          </div>
        </div>
      </div>);
    },
});
